import { cva } from 'class-variance-authority';

export const textVariants = cva('transition-all duration-150', {
  variants: {
    type: {
      default: '',
      h1: 'font-h1',
      h2: 'font-h2',
      h3: 'font-h3',
      caption: 'font-caption',
      label: 'font-label',
      'body-big': 'font-body-big',
    },
    weight: {
      default: '',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    color: {
      default: '',
      body: 'text-body',
      brand: 'text-brand',
      muted: 'text-muted',
      lilac: 'text-lilac',
      header: 'text-header',
      dark: 'text-dark',
      light: 'text-light',
      alert: 'text-alert',
    },
    align: {
      default: '',
      center: 'text-center',
    },
  },
  defaultVariants: {
    type: 'default',
    weight: 'default',
    color: 'default',
    align: 'default',
  },
});
